import React from 'react';
import { connect } from 'react-redux'
import ListadoProductos from './ListadoProductos.jsx';

//Importación de actions.
import {
    getScreenData,
    selectAllCheckbox,
    clickCheckbox,
    changeStates,
    resetState,
    changeStateWithCheckSelection,
    disableButton,
    filterCheckbox,
    searchUser,
    orderColumn,
    updateMotivoBloqueo,
    deleteProductos,
    routeToNuevoProducto,
    routeToEditarProducto
} from '../actions/ListadoProductosActions.js';

const mapStateToProps = (state) => {
    return {
        data: state.listadoProductos.data,
        redirect: state.listadoProductos.redirect,
        isFetching: state.listadoProductos.isFetching,
        error: state.listadoProductos.error
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        resetState: () => {
            dispatch(resetState());
        },
        getScreenData: (state, currentScope) => {
            dispatch(getScreenData(state, currentScope));
        },

        selectAllCheckbox: () => {
            dispatch(selectAllCheckbox());
        },
        clickCheckbox: (Id) => {
            dispatch(clickCheckbox(Id));
        },
        changeStates: () => {
            dispatch(changeStates());
        },
        changeStateWithCheckSelection: () => {
            dispatch(changeStateWithCheckSelection());
        },
        disableButton: () => {
            dispatch(disableButton());
        },
        filterCheckbox: () => {
            dispatch(filterCheckbox());
        },
        searchUser: () => {
            dispatch(searchUser());
        },
        orderColumn: (Id) => {
            dispatch(orderColumn(Id));
        },
        updateMotivoBloqueo: () => {
            dispatch(updateMotivoBloqueo());
        },
        deleteProductos: () => {
            dispatch(deleteProductos());
        },
        routeToNuevoProducto: () => {
            dispatch(routeToNuevoProducto());
        },
        routeToEditarProducto: (id) => {
            dispatch(routeToEditarProducto(id));
        }
    }
}

//Connect entre el componente y las props y actions.
const ListadoProductosContainer = connect(mapStateToProps, mapDispatchToProps)(ListadoProductos);

export default ListadoProductosContainer;